<template>
  <div>
    <div
      class="dashboard-head d-flex align-items-center border-bottom pb-2 mb-3"
      v-if="!errorMessage"
    >
      <h1 class="h2">
        <span class="text-danger">Тест {{ current.id }}</span
        >. {{ typeDataTitle }}. {{ subjectDataTitle }}
      </h1>
    </div>
    <div class="dashboard-body py-2">
      <b-overlay
        no-wrap
        :show="loader"
        rounded="sm"
        variant="white"
        opacity=".85"
        blur="4px"
        :fixed="true"
      >
      </b-overlay>

      <div class="timer" v-if="!hasError">
        <BIconAlarm /> {{ totalTime | timer }}:{{ timerSeconds }}
      </div>
      <b-card
        tag="div"
        style="max-width: 100%"
        class="mb-3"
        v-for="(q, index) in current.questions"
        :key="index"
      >
        <h5 class="question-text">
          <span class="text-danger question-text__number">
            {{ index + 1 }}.
          </span>
          <span v-html="q.text"></span>
        </h5>

        <b-card-text class="mt-4">
          <b-form-group v-if="q.type === 10">
            <b-form-radio
              :name="`q-${q.id}`"
              v-for="(a, inx) in q.answers"
              :key="inx"
              :value="a.answer_hash"
              @change="setAnswer(index, a.id)"
            >
              {{ a.text }}
            </b-form-radio>
          </b-form-group>
          <b-input-group v-else>
            <template #prepend>
              <b-input-group-text>Ответ:</b-input-group-text>
            </template>
            <b-form-input
              v-for="(a, inx) in q.answers"
              :key="inx"
              @change="setAnswer(index, a.id)"
            >
            </b-form-input>
          </b-input-group>
        </b-card-text>
      </b-card>

      <div class="text-right" v-if="!hasError">
        <b-button variant="success" @click="onFinish">Завершить</b-button>
      </div>

      <b-alert variant="warning" :show="hasError">
        {{ errorMessage }}
      </b-alert>

      <div v-if="hasError">
        <router-link to="/dashboard" class="btn btn-outline-secondary btn-sm">
          Назад
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { BIconAlarm } from 'bootstrap-vue';
import msg from '@/utils/messages';
// require('https://polyfill.io/v3/polyfill.min.js?features=es6');
// require('https://cdn.jsdelivr.net/npm/mathjax@3.0.1/es5/tex-mml-chtml.js');

export default {
  components: {
    BIconAlarm
  },
  metaInfo() {
    return {
      title: msg.PAGE_TITLE_EXAM + ' ' + this.current.id,
      titleTemplate: `${this.siteName || ''} - %s`
    };
  },
  data() {
    return {
      loader: true,
      current: [],
      hasError: false,
      errorMessage: false,
      userAnswers: [],
      timer: null,
      totalTime: 120,
      timerSeconds: null
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    typeDataTitle() {
      return this.current.typeData?.title;
    },
    subjectDataTitle() {
      return this.current.subjectData?.title;
    },
    siteName() {
      return this.$store.getters.getSiteParams?.siteName;
    }
  },
  methods: {
    reRender() {
      if (window.MathJax) {
        window.MathJax.Hub.Queue(['Typeset', window.MathJax.Hub]);
      }
    },
    setAnswer(i, answer) {
      console.log(answer);
      this.userAnswers[i].a = answer;
      this.userAnswers[i].value = event.target.value;
      // this.userAnswers
    },
    async onFinish() {
      try {
        const id = this.$route.params.id;
        const result = await this.$store.dispatch('finish', {
          answers: this.userAnswers,
          id
        });
        if (result) {
          this.$router.push(`/exam/r/${id}`);
        }
      } catch (e) {
        //
      }
    },
    startTimer() {
      this.timer = setInterval(() => {
        this.totalTime--;
        if (this.timerSeconds > 0) {
          this.timerSeconds--;
          if (this.timerSeconds < 10)
            this.timerSeconds = '0' + this.timerSeconds;
        } else {
          this.timerSeconds = 59;
        }
      }, 1000);
    },
    stopTimer() {
      clearInterval(this.timer);
    }
  },
  watch: {
    async totalTime(second) {
      if (second <= 0) {
        this.stopTimer();
        this.loader = true;
        await this.onFinish();
      }
    }
  },
  destroyed() {
    this.stopTimer();
  },
  async mounted() {
    this.errorMessage = false;
    try {
      const id = this.$route.params.id;
      const data = await this.$store.dispatch('exam', id);
      this.current = data.model;
      this.totalTime = Number(data.timeLeft) * 60;
      this.loader = false;
      this.hasError = false;
      this.timerSeconds = data.secondLeft;

      this.userAnswers = this.current.questions.map(q => {
        return { type: q.type, q: q.id, a: '', value: '' };
      });
      setTimeout(() => this.reRender(), 0);
      this.startTimer();
    } catch (e) {
      this.errorMessage = e.response.data.message;
      this.hasError = true;
      this.loader = false;
    }
  }
};
</script>
<style lang="scss">
.timer {
  position: fixed;
  z-index: 9;
  top: 88px;
  right: 1.5rem;
  font-size: 22px;
  font-weight: 700;
  // background-color: ghostwhite;
  background-color: #e85353;
  color: white;
  padding: 8px 18px;
  box-shadow: 0px 4px 4px rgba(50, 50, 71, 0.08),
    0px 6px 8px rgba(50, 50, 71, 0.08);
  border-radius: 0.25rem;
}

.question-text {
  display: flex;
  align-items: flex-start;

  span {
    display: inline-block;
  }

  img {
    // display: block;
    margin: 10px 0px;
    max-width: 100%;
  }

  & > &__number {
    display: block;
    margin-right: 10px;
  }
}
</style>
